import { Component } from '@angular/core';
import { NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { GoogleAnalyticsService } from '../../../../../user/google-analytics.service';
import { ModalService } from '../../../../../shared/services/modal.service';

type TeaserIcon = 'segments' | 'hourly' | 'trucks' | 'monthly';

interface TeaserCard {
  icon: TeaserIcon;
  title: string;
  text: string;
}

const CARDS: TeaserCard[] = [
  {
    icon: 'segments',
    title: 'AADT per road segment',
    text: 'Average daily vehicles on every segment, local streets included.',
  },
  {
    icon: 'hourly',
    title: 'Hour by hour',
    text: 'When the cars pass: the morning, lunch and evening peaks.',
  },
  {
    icon: 'trucks',
    title: 'Truck share',
    text: 'The % of trucks against passenger cars on each road.',
  },
  {
    icon: 'monthly',
    title: 'Month by month',
    text: 'How traffic swings through the seasons of the year.',
  },
];

/**
 * The popup's Traffic tab: a fake door for segment-level vehicle traffic.
 * Nothing is fetched - the cards describe the product and the button counts
 * the visitors who want it (`user_wants_traffic`) before it is built.
 */
@Component({
  selector: 'app-traffic-teaser',
  templateUrl: './traffic-teaser.component.html',
  styleUrls: ['./traffic-teaser.component.scss'],
  imports: [NgFor, NgSwitch, NgSwitchCase],
})
export class TrafficTeaserComponent {
  protected readonly cards = CARDS;

  constructor(
    private ga: GoogleAnalyticsService,
    private modalService: ModalService
  ) {}

  public handleRequest(): void {
    this.ga.logUserWantsTraffic();
    // No `actionType`: the button only closes the dialog.
    this.modalService.openModal({
      headerText: 'Road-by-road traffic is coming soon',
      mainText:
        'We are finishing segment-level vehicle traffic for the map: daily ' +
        'counts on every road, hourly and monthly patterns, and truck share. ' +
        'The data is based on ticon.co traffic counts, which combine public ' +
        'DOT counts with mobile data to cover the whole US with accurate AADTs.',
      additionalText:
        'It will appear right here in this tab - please check back for ' +
        'updates. Thank you for your interest!',
      buttonText: 'Got it',
    });
  }
}
